import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { UserResult } from '@/api/user';

export const useAuthStore = defineStore('auth', () => {
  const user = ref<UserResult>();
  const isInitialized = ref(false);

  const setUser = async (data?: UserResult) => {
    try {
      user.value = data;
    } catch (e) {
      console.error(e);
    }
  };

  const setInitialized = () => {
    isInitialized.value = true;
  };

  return {
    user,
    isInitialized,
    setUser,
    setInitialized,
  };
});
